export default {
    setPeople(state, people) {
        state.people = people;
    },
    setError(state, error) {
        state.error = error.toString();
    },
    setPerson(state, person) {
        state.person = person;
    },
    setGenders(state, genders) {
        state.genders = genders;
    },
    setSchoolYears(state, schoolYears) {
        state.schoolYears = schoolYears;
    },
    setLocations(state, locations) {
        state.locations = locations;
    },
    setRoles(state, roles) {
        state.roles = roles;
    }
};
